/* WOW.js replacement - Intersection Observer API (zero dependencies) */
(function () {
  function initWow() {
    const elements = document.querySelectorAll('.wow');
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const delay = el.getAttribute('data-wow-delay') || '0s';
          const duration = el.getAttribute('data-wow-duration') || '1s';
          el.style.animationDelay = delay;
          el.style.animationDuration = duration;
          el.style.visibility = 'visible';
          el.classList.add('animated');
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(el => {
      el.style.visibility = 'hidden';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWow);
  } else {
    initWow();
  }
})();
